import { render, staticRenderFns } from "./RecurringInvestors.vue?vue&type=template&id=f54f7280&"
import script from "./RecurringInvestors.vue?vue&type=script&lang=ts&"
export * from "./RecurringInvestors.vue?vue&type=script&lang=ts&"
import style0 from "./RecurringInvestors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports